// Team data structure with logos, bye weeks, and other information.
// Bye weeks reflect the 2026 NFL season.
// O-line ranks (1 = best, 32 = worst) — consensus average across three
// sources, re-ranked to smooth out disagreements (refreshed 8/8/2026):
//   Sharp Football Analysis (6/30/2026): https://www.sharpfootballanalysis.com/analysis/best-nfl-offensive-line-rankings/
//   FantasyPros (7/18/2026): https://www.fantasypros.com/2026/07/nfl-offensive-line-rankings-2026-fantasy-football/
//   StatRankings.com (7/23/2026): https://statrankings.com/nfl/offensive-line-rankings
export const teamData = {
    'ARI': {
        name: 'Arizona Cardinals',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/ari.png',
        byeWeek: 14,
        conference: 'NFC',
        division: 'West',
        primaryColor: '#97233F',
        olineRank: 28
    },
    'ATL': {
        name: 'Atlanta Falcons',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/atl.png',
        byeWeek: 11,
        conference: 'NFC',
        division: 'South',
        primaryColor: '#A71930',
        olineRank: 16
    },
    'BAL': {
        name: 'Baltimore Ravens',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/bal.png',
        byeWeek: 13,
        conference: 'AFC',
        division: 'North',
        primaryColor: '#241773',
        olineRank: 23
    },
    'BUF': {
        name: 'Buffalo Bills',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/buf.png',
        byeWeek: 7,
        conference: 'AFC',
        division: 'East',
        primaryColor: '#00338D',
        olineRank: 4
    },
    'CAR': {
        name: 'Carolina Panthers',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/car.png',
        byeWeek: 5,
        conference: 'NFC',
        division: 'South',
        primaryColor: '#0085CA',
        olineRank: 9
    },
    'CHI': {
        name: 'Chicago Bears',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/chi.png',
        byeWeek: 10,
        conference: 'NFC',
        division: 'North',
        primaryColor: '#0B162A',
        olineRank: 3
    },
    'CIN': {
        name: 'Cincinnati Bengals',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/cin.png',
        byeWeek: 6,
        conference: 'AFC',
        division: 'North',
        primaryColor: '#FB4F14',
        olineRank: 26
    },
    'CLE': {
        name: 'Cleveland Browns',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/cle.png',
        byeWeek: 11,
        conference: 'AFC',
        division: 'North',
        primaryColor: '#311D00',
        olineRank: 31
    },
    'DAL': {
        name: 'Dallas Cowboys',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/dal.png',
        byeWeek: 14,
        conference: 'NFC',
        division: 'East',
        primaryColor: '#003594',
        olineRank: 21
    },
    'DEN': {
        name: 'Denver Broncos',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/den.png',
        byeWeek: 10,
        conference: 'AFC',
        division: 'West',
        primaryColor: '#FB4F14',
        olineRank: 1
    },
    'DET': {
        name: 'Detroit Lions',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/det.png',
        byeWeek: 6,
        conference: 'NFC',
        division: 'North',
        primaryColor: '#0076B6',
        olineRank: 11
    },
    'GB': {
        name: 'Green Bay Packers',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/gb.png',
        byeWeek: 11,
        conference: 'NFC',
        division: 'North',
        primaryColor: '#203731',
        olineRank: 29
    },
    'HOU': {
        name: 'Houston Texans',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/hou.png',
        byeWeek: 8,
        conference: 'AFC',
        division: 'South',
        primaryColor: '#03202F',
        olineRank: 30
    },
    'IND': {
        name: 'Indianapolis Colts',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/ind.png',
        byeWeek: 13,
        conference: 'AFC',
        division: 'South',
        primaryColor: '#002C5F',
        olineRank: 8
    },
    'JAX': {
        name: 'Jacksonville Jaguars',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/jax.png',
        byeWeek: 7,
        conference: 'AFC',
        division: 'South',
        primaryColor: '#006778',
        olineRank: 17
    },
    'KC': {
        name: 'Kansas City Chiefs',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/kc.png',
        byeWeek: 5,
        conference: 'AFC',
        division: 'West',
        primaryColor: '#E31837',
        olineRank: 18
    },
    'LAC': {
        name: 'Los Angeles Chargers',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/lac.png',
        byeWeek: 7,
        conference: 'AFC',
        division: 'West',
        primaryColor: '#0080C6',
        olineRank: 6
    },
    'LAR': {
        name: 'Los Angeles Rams',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/lar.png',
        byeWeek: 11,
        conference: 'NFC',
        division: 'West',
        primaryColor: '#003594',
        olineRank: 5
    },
    'LV': {
        name: 'Las Vegas Raiders',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/lv.png',
        byeWeek: 13,
        conference: 'AFC',
        division: 'West',
        primaryColor: '#000000',
        olineRank: 25
    },
    'MIA': {
        name: 'Miami Dolphins',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/mia.png',
        byeWeek: 6,
        conference: 'AFC',
        division: 'East',
        primaryColor: '#008E97',
        olineRank: 27
    },
    'MIN': {
        name: 'Minnesota Vikings',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/min.png',
        byeWeek: 6,
        conference: 'NFC',
        division: 'North',
        primaryColor: '#4F2683',
        olineRank: 10
    },
    'NE': {
        name: 'New England Patriots',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/ne.png',
        byeWeek: 11,
        conference: 'AFC',
        division: 'East',
        primaryColor: '#002244',
        olineRank: 15
    },
    'NO': {
        name: 'New Orleans Saints',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/no.png',
        byeWeek: 8,
        conference: 'NFC',
        division: 'South',
        primaryColor: '#D3BC8D',
        olineRank: 12
    },
    'NYG': {
        name: 'New York Giants',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/nyg.png',
        byeWeek: 8,
        conference: 'NFC',
        division: 'East',
        primaryColor: '#0B2265',
        olineRank: 20
    },
    'NYJ': {
        name: 'New York Jets',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/nyj.png',
        byeWeek: 13,
        conference: 'AFC',
        division: 'East',
        primaryColor: '#125740',
        olineRank: 19
    },
    'PHI': {
        name: 'Philadelphia Eagles',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/phi.png',
        byeWeek: 10,
        conference: 'NFC',
        division: 'East',
        primaryColor: '#004C54',
        olineRank: 2
    },
    'PIT': {
        name: 'Pittsburgh Steelers',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/pit.png',
        byeWeek: 9,
        conference: 'AFC',
        division: 'North',
        primaryColor: '#FFB612',
        olineRank: 22
    },
    'SEA': {
        name: 'Seattle Seahawks',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/sea.png',
        byeWeek: 11,
        conference: 'NFC',
        division: 'West',
        primaryColor: '#002244',
        olineRank: 13
    },
    'SF': {
        name: 'San Francisco 49ers',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/sf.png',
        byeWeek: 8,
        conference: 'NFC',
        division: 'West',
        primaryColor: '#AA0000',
        olineRank: 14
    },
    'TB': {
        name: 'Tampa Bay Buccaneers',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/tb.png',
        byeWeek: 10,
        conference: 'NFC',
        division: 'South',
        primaryColor: '#D50A0A',
        olineRank: 7
    },
    'TEN': {
        name: 'Tennessee Titans',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/ten.png',
        byeWeek: 9,
        conference: 'AFC',
        division: 'South',
        primaryColor: '#0C2340',
        olineRank: 32
    },
    'WAS': {
        name: 'Washington Commanders',
        logo: 'https://a.espncdn.com/i/teamlogos/nfl/500/was.png',
        byeWeek: 7,
        conference: 'NFC',
        division: 'East',
        primaryColor: '#5A1414',
        olineRank: 24
    },
    'FA': {
        name: 'Free Agent',
        logo: null,
        byeWeek: null,
        conference: null,
        division: null,
        primaryColor: '#9CA3AF',
        olineRank: null
    }
};

// Projected 2026 defense ranks (1 = best, 32 = worst). Consensus of two
// preseason sources — The Gameday power rankings and Sportsnaut — averaged
// and re-ranked to smooth out disagreements (refreshed 8/8/2026, pulling
// The Gameday's 8/6/2026 update):
//   https://thegameday.com/nfl/power-rankings/defense/
//   https://sportsnaut.com/nfl/nfl-defense-rankings
export const DEFENSE_RANK_2026 = {
    HOU: 1, LAR: 2, SEA: 3, PHI: 4, DEN: 5, NE: 6, MIN: 7, JAX: 8,
    BAL: 9, PIT: 10, GB: 11, CLE: 12, DET: 13, SF: 14, IND: 15, DAL: 16,
    CHI: 17, NYG: 18, KC: 19, LAC: 20, BUF: 21, ATL: 22, TB: 23, CAR: 24,
    CIN: 25, NO: 26, WAS: 27, NYJ: 28, TEN: 29, LV: 30, ARI: 31, MIA: 32,
};

// Fold the projected defense rank onto each team record so it sits alongside
// olineRank rather than being looked up separately.
Object.entries(DEFENSE_RANK_2026).forEach(([abbr, rank]) => {
    if (teamData[abbr]) teamData[abbr].defenseRank = rank;
});

// Helper function to get team data by abbreviation
export const getTeamData = (teamAbbr) => {
    return teamData[teamAbbr] || null;
};

// Helper function to get team logo by abbreviation
export const getTeamLogo = (teamAbbr) => {
    const team = teamData[teamAbbr];
    return team ? team.logo : null;
};

// Helper function to get bye week by abbreviation
export const getByeWeek = (teamAbbr) => {
    const team = teamData[teamAbbr];
    return team ? team.byeWeek : null;
};

// Helper function to get O-line ranking by abbreviation
export const getOlineRank = (teamAbbr) => {
    const team = teamData[teamAbbr];
    return team ? team.olineRank : null;
};

// Helper function to get projected 2026 defense ranking by abbreviation
export const getDefenseRank = (teamAbbr) => {
    const team = teamData[teamAbbr];
    return team ? (team.defenseRank ?? null) : null;
};

// Helper function to get all teams
export const getAllTeams = () => {
    return Object.keys(teamData).map(abbr => ({
        abbreviation: abbr,
        ...teamData[abbr]
    }));
};
